import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var GridIcon = function GridIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "GridIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 2.853C1 1.83 1.83 1 2.853 1h2.059c1.023 0 1.853.83 1.853 1.853v2.059c0 1.023-.83 1.853-1.853 1.853h-2.06A1.853 1.853 0 0 1 1 4.912zm1.853-.206a.206.206 0 0 0-.206.206v2.059c0 .113.092.206.206.206h2.059a.206.206 0 0 0 .206-.206v-2.06a.206.206 0 0 0-.206-.205zM1 11.088c0-1.023.83-1.853 1.853-1.853h2.059c1.023 0 1.853.83 1.853 1.853v2.06c0 1.022-.83 1.852-1.853 1.852h-2.06A1.853 1.853 0 0 1 1 13.147zm1.853-.206a.206.206 0 0 0-.206.206v2.06c0 .113.092.205.206.205h2.059a.206.206 0 0 0 .206-.206v-2.059a.206.206 0 0 0-.206-.206zM9.235 2.853c0-1.023.83-1.853 1.853-1.853h2.06C14.17 1 15 1.83 15 2.853v2.059c0 1.023-.83 1.853-1.853 1.853h-2.059a1.853 1.853 0 0 1-1.853-1.853zm1.853-.206a.206.206 0 0 0-.206.206v2.059c0 .113.093.206.206.206h2.06a.206.206 0 0 0 .205-.206v-2.06a.206.206 0 0 0-.206-.205zM9.235 11.088c0-1.023.83-1.853 1.853-1.853h2.06c1.022 0 1.852.83 1.852 1.853v2.06C15 14.17 14.17 15 13.147 15h-2.059a1.853 1.853 0 0 1-1.853-1.853zm1.853-.206a.206.206 0 0 0-.206.206v2.06c0 .113.093.205.206.205h2.06a.206.206 0 0 0 .205-.206v-2.059a.206.206 0 0 0-.206-.206z",
      clipRule: "evenodd"
    })
  }));
};

export { GridIcon };
